import { HttpContextToken } from '@angular/common/http';

/** Marks a request as already retried after token refresh (internal only). */
export const AUTH_RETRY = new HttpContextToken<boolean>(() => false);
